module.exports = __webpack_public_path__ + "img/pro-photo14.a63ec614.jpg";